// 최근 1달간 분석 데이터
export class Analysis {
  // 총 문제
  problemCorrect: {
    correctCount: number
    totalCount: number
    wrongCount: number
    rate: number // 정답율. INT
  }
  // 개념별
  conceptCorrectList: {
    conceptId: number
    conceptName: string
    correctCount: number
    curriculumId: number
    totalCount: number
    wrongCount: number
    rate: number // 정답율
  }[]

  constructor(data: res.Analysis) {
    this.problemCorrect = data.problemCorrect
    this.conceptCorrectList = data.conceptCorrectList
  }
}
